import { io, Socket as SIOSocket } from "socket.io-client";
import { DEFAULT_TIMEOUT_MS } from "./consts";
import {
  IControlSource,
  SocketEvent,
  SocketEventHandler,
  ControlSourceTimeoutHelper,
  Subscriber,
} from "./base";
import { wsAddress } from "../address";

export const WEBROSPROXY_PORT = 3000;

export class WebROSProxyControlSource implements IControlSource {
  socket: SIOSocket;
  timeoutHelper: ControlSourceTimeoutHelper;
  subscribers: SocketEventHandler[];
  constructor(
    host: string,
    {
      timeoutMs = DEFAULT_TIMEOUT_MS,
      port = WEBROSPROXY_PORT,
      useSSL = true,
    } = {}
  ) {
    this.socket = io(wsAddress({ host, port, useSSL }));
    this.timeoutHelper = new ControlSourceTimeoutHelper(this);
    this.cancelTimeoutOn(["close", "connect", "error"]);
    this.timeoutHelper.schedule(timeoutMs);
    this.subscribers = [];
  }

  get nativeSocket() {
    return this.socket;
  }

  isConnected() {
    return this.socket.connected;
  }

  close() {
    this.socket.close();
  }

  isClosed() {
    return this.socket.disconnected;
  }

  send = (event: string, data = {}) => this.socket.emit(event, data);

  subscribe = (event: string, subscriber: Subscriber) => {
    if (this.socket.listeners(event).includes(subscriber)) return;

    this.socket.emit("subscribe", event);
    this.socket.on(event, subscriber);
  };
  unsubscribe = (event: string, subscriber: Subscriber) => {
    this.socket.emit("unsubscribe", event);
    this.socket.off(event, subscriber);
  };

  cancelTimeoutOn(events: Array<SocketEvent> = []) {
    for (const event of events) {
      this.socket.on(event, () => {
        this.timeoutHelper.cancel();
      });
    }
  }

  onDisconnect(cb: SocketEventHandler) {
    this.socket.on("close", (reason, desc) => cb());
  }

  onConnect(cb: SocketEventHandler) {
    this.socket.on("connect", () => cb());
  }

  onError(cb: SocketEventHandler) {
    this.socket.on("error", () => cb());
    this.timeoutHelper.onTimeout(cb);
  }
}

export type WebROSProxyControlSourceArgs = ConstructorParameters<
  typeof WebROSProxyControlSource
>;
